import { useTranslation } from 'react-i18next'

import AccountIcon from '@wwt/shared/assets/icons/outline/account.svg'

import { TranslationsMenu } from '@/features/translation'
import { useSession } from '@/shared/lib/hooks/useSession'
import { NestedMenuContent, NestedMenuItem } from '@/shared/ui/NestedMenu'

import { AccountSettingsNestedItem } from './items/AccountSettings'
import { ChatNestedItem } from './items/Chat'
import { LogOutNestedItem } from './items/LogOut'
import { MyTravelsNestedItem } from './items/MyTravels'
import { RestartTutorialNestedItem } from './items/RestartTutorial'

// TODO: Move this to widgets and compose on app level
export const AccountMenu = () => {
	const { t } = useTranslation('header')

	const token = useSession.use.token()

	return (
		<>
			<NestedMenuItem to="account">
				<AccountIcon />
				{t('accountMenu.title')}
			</NestedMenuItem>
			<NestedMenuContent path="account">
				<AccountSettingsNestedItem />
				<MyTravelsNestedItem />
				<ChatNestedItem />
				<RestartTutorialNestedItem />
				{/* FIXME: Translations menu shouldn't be here, we can't import features in another feature */}
				<TranslationsMenu />
				{token && <LogOutNestedItem />}
			</NestedMenuContent>
		</>
	)
}
